import { FieldDataNode } from "rc-tree";
import { ExplorerDataNode } from "../treeDataManipulation";

export const createNewFile = (name: string, targetNode: FieldDataNode<ExplorerDataNode>) => {
  let filePath;
  name = name.trim();

  if (targetNode.isLeaf) {
    filePath = targetNode.parentNode ? targetNode.parentNode.key.endsWith("/") ? `/${name}` : `${targetNode.parentNode.key}/${name}` : `/${name}`;
  } else {
    filePath = targetNode.key.endsWith("/") ? `${targetNode.key}${name}` : `${targetNode.key}/${name}`;
  }

  return filePath;
}
